module.exports = __webpack_public_path__ + "static/media/discountIcon.6a27df91.svg";